export const OCTADESK_SCRIPT_ID = 'octadesk-embed'
export const OCTADESK_SCRIPT_SRC = 'https://cdn.octadesk.com/embed.js'
export const OCTADESK_APP_ID = 'octadesk-octachat-appchat'
export const OCTADESK_CHAT_OPEN_CLASS = 'octadesk-chat-open'
export const OCTADESK_LAYOUT_BURST_MAX = 8
export const OCTADESK_LAYOUT_RETRY_DELAYS_MS = [0, 50, 100, 300, 350, 600, 1200, 2000] as const
export const OCTADESK_CHAT_RIGHT = '1.5rem'
export const OCTADESK_PANEL_LAYOUT_MIN_HEIGHT_PX = 220
export const OCTADESK_PANEL_LAYOUT_MIN_WIDTH_PX = 280
export const OCTADESK_CHAT_MAX_WIDTH_PX = 400
export const OCTADESK_CHAT_MAX_HEIGHT_PX = 560
export const OCTADESK_FAB_GAP_PX = 0
/** Abaixo do menu lateral (z-40) e drawer mobile (z-50). */
export const OCTADESK_CHAT_Z_INDEX = 35
/** Acima do painel Octadesk; ainda abaixo do menu. */
export const FLOATING_CHAT_ACTIONS_Z_INDEX = 36

export const OCTADESK_DOM_SELECTOR =
  '.octadesk-octachat-app, .octadesk-app, [id^="octadesk"]'
